export { KNGoogleMap } from './KNGoogleMap';
